import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IExhibitorOrdersPayloadState } from '@app-store/slices/companyStatistics/exhibitorOrders'

interface TaskAction extends Action {
    payload: IExhibitorOrdersPayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.companyStatistics.exhibitorOrders

function* exhibitorOrdersSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/companies/stats/exhibitor/orders`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* exhibitorOrdersSaga(): any {
    yield takeLatest<TaskAction>(onRequest, exhibitorOrdersSagaTask)
}

export default exhibitorOrdersSaga
